export default __webpack_public_path__ + "static/bg-4-6ad5203c5b09c04380d6923ff9b82685.jpg";